import { Sampling, SamplingMainData, SamplingConfig } from './Sampling';

let trackInstance: Sampling | undefined = undefined;

const handler = {
  get: (_target: unknown, objectKey: any) => {
    return trackInstance?.[objectKey as keyof Sampling];
  },
};

export const samplingInit = (config: SamplingConfig, mainData: SamplingMainData) => {
  trackInstance = new Sampling(config, mainData);
  return trackInstance;
};

export const sampling = new Proxy({}, handler) as Sampling;
